// Grabs the user's attention for an urgent alert when the GaitMetrics tab
// isn't focused: flashes the tab title and (if permitted) shows an OS-level
// notification, which is what makes Chrome's taskbar/dock icon flash too.

let flashIntervalId = null;
let originalTitle = null;

export const requestNotificationPermission = () => {
  if (typeof Notification !== "undefined" && Notification.permission === "default") {
    Notification.requestPermission();
  }
};

const startTitleFlash = (flashText) => {
  if (flashIntervalId) return;

  originalTitle = document.title;
  let showingFlash = false;

  flashIntervalId = setInterval(() => {
    document.title = showingFlash ? originalTitle : `🔴 ${flashText}`;
    showingFlash = !showingFlash;
  }, 1000);
};

const stopTitleFlash = () => {
  if (flashIntervalId) {
    clearInterval(flashIntervalId);
    flashIntervalId = null;
  }
  if (originalTitle) {
    document.title = originalTitle;
    originalTitle = null;
  }
};

export const notifyAlert = ({ title = "GaitMetrics Alert", body = "A new alert has been triggered." } = {}) => {
  // Only bother grabbing attention if the user isn't actively looking at the tab
  if (document.hidden || !document.hasFocus()) {
    startTitleFlash(title);

    if (typeof Notification !== "undefined" && Notification.permission === "granted") {
      try {
        const notification = new Notification(title, {
          body,
          tag: "gaitmetrics-alert",
          renotify: true,
        });
        notification.onclick = () => {
          window.focus();
          notification.close();
        };
      } catch (error) {
        console.error("Notification error:", error);
      }
    }

    // Badges the taskbar/dock icon. Only has a visible effect if the page is
    // installed as an app (Chrome/Edge "Install GaitMetrics..."); a regular
    // browser tab shares the browser's own icon, which pages aren't allowed
    // to bounce or highlight for security reasons.
    if (navigator.setAppBadge) {
      navigator.setAppBadge().catch(() => {});
    }
  }
};

export const clearAlertAttention = () => {
  stopTitleFlash();
  if (navigator.clearAppBadge) {
    navigator.clearAppBadge().catch(() => {});
  }
};

if (typeof window !== "undefined") {
  window.addEventListener("focus", stopTitleFlash);
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) stopTitleFlash();
  });
}
